import fetchNetworkOutcomes from './fetchNetworkOutcomes';

export default function fetchNetworkAssistanceRequestOutcomes(networkId, serviceTypeId, params = {}) {
  return fetchNetworkOutcomes(networkId, serviceTypeId, {
    applicable_states: ['assistance_requested'],
    ...params,
  });
}
